import React, { useState } from 'react'
import SignIn from '@/components/auth/SignIn'
import SignUp from '@/components/auth/SignUp'
import ForgotPassword from '@/components/auth/ForgotPassword'
import LanguageToggle from '@/components/LanguageToggle'
import { isInIframe } from '@/utils/iframeDetector'

type AuthMode = 'signIn' | 'signUp' | 'forgotPassword'

interface AuthPageProps {
  initialMode?: AuthMode
}

const AuthPage: React.FC<AuthPageProps> = ({ initialMode = 'signIn' }) => {
  const [mode, setMode] = useState<AuthMode>(initialMode)

  return (
    <div className="min-h-screen bg-white relative">
      {!isInIframe() && (
        <div className="absolute top-4 right-4">
          <LanguageToggle />
        </div>
      )}
      {mode === 'signUp' && <SignUp onSwitchToSignIn={() => setMode('signIn')} />}
      {mode === 'forgotPassword' && <ForgotPassword onSwitchToSignIn={() => setMode('signIn')} />}
      {mode === 'signIn' && (
        <SignIn
          onSwitchToSignUp={() => setMode('signUp')}
          onSwitchToForgotPassword={() => setMode('forgotPassword')}
        />
      )}
    </div>
  )
}

export default AuthPage
